// TODO move fetching from component to page
// eslint-disable-next-line internal-rules/no-restricted-prefetch-imports
import { withPrefetchedData } from 'src/shared/prefetch';

import { MembershipAwarenessContainerSunrise } from './container/MembershipAwarenessContainerSunrise';
import type { MembershipAwarenessFormPrefetchedDataProps } from './formContext';
import { MembershipAwarenessFormContextProvider, prefetchFormContext } from './formContext';
import type { Props } from './shared/types';

type MembershipAwarenessProps = MembershipAwarenessFormPrefetchedDataProps & Props;

export const MembershipAwarenessSunrise = withPrefetchedData(
	function MembershipAwarenessEntry({ prefetchedData, petitionId, ...props }: MembershipAwarenessProps) {
		return (
			<MembershipAwarenessFormContextProvider prefetchedData={prefetchedData} petitionId={petitionId}>
				<MembershipAwarenessContainerSunrise {...props} />
			</MembershipAwarenessFormContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchFormContext(context),
	},
);
